export default __webpack_public_path__ + "static/media/goodTea2.404d0c86.png";